<template>
  <b-card class="mt-4">
    <div>
      <h4 class="d-inline">Wykres przepracowanych godzin w danym okresie</h4>
      <font-awesome-icon
        class="text-secondary float-right"
        v-b-popover.hover="'Ustawienia wykresu'"
        style="cursor:pointer; font-size: 1.5em;"
        icon="cog"
        v-b-toggle.settings
      ></font-awesome-icon>
    </div>
    <b-collapse id="settings">
      <b-row>
        <b-col cols="4">
          <b-form-group label="Okres">
            <b-form-select @change="periodChange" v-model="period" :options="periodOptions" />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="Liczba okresów">
            <b-form-input @change="quantityChange" type="number" step="1" v-model="quantity" max="6" min="1"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="Data początku">
            <date-picker
              class="date-picker w-100"
              style="width: 190px"
              inputClass="form-control"
              v-model="startDate"
              :language="dpLanguage"
              :format="'dd.MM.yyyy'"
              @selected="dateChange"
            ></date-picker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-collapse>
    <GChart type="BarChart" :data="chartData" :resizeDebounce="500" :options="chartOptions" />
  </b-card>
</template>
<script>
import DatePicker from 'vuejs-datepicker';
import { pl } from 'vuejs-datepicker/dist/locale';
import { GChart } from 'vue-google-charts';
import { StatisticResource } from '@/resources/statistic.resource';
import statisticsService from '@/services/statistics.service';

import moment from 'moment';
export default {
  components: {
    DatePicker,
    GChart
  },
  props: { id: Number },
  data() {
    return {
      stats: [],
      periodOptions: [{ value: 0, text: 'Tydzień' }, { value: 1, text: 'Miesiąc' }],
      dpLanguage: pl,
      period: 0,
      quantity: 4,
      startDate: new Date(),
      today: new Date(),
      chartData: [],
      chartOptions: {
        height: 350,
        animation: { startup: true, duration: 500, easing: 'inAndOut' },
        legend: { position: 'none' },
        chartArea: { left: '20%', width: '80%', height: '80%' },
        bar: { groupWidth: '61.8%' },
        fontSize: 13,
        hAxis: {
          minValue: 0,
          direction: 1
        }
      }
    };
  },
  methods: {
    async getPeriodicalStats() {
      try {
        const stats = JSON.parse(await StatisticResource.periodicalStats(this.period, this.quantity, this.startDate, this.id));
        this.$set(this, 'stats', stats);
        this.$set(this, 'chartData', statisticsService.statisticToChartData(this.stats));
      } catch (error) {
        console.warn(error);
      }
    },
    periodChange(val) {
      this.period = val;
      this.getPeriodicalStats();
      const settings = { period: this.period, quantity: this.quantity };
      localStorage.setItem('settings', JSON.stringify(settings));
    },
    quantityChange(val) {
      this.quantity = parseInt(val, 10);
      if (this.quantity > 6) {
        this.quantity = 6;
      }
      if (this.quantity < 1) {
        this.quantity = 1;
      }
      this.getPeriodicalStats();
      const settings = { period: this.period, quantity: this.quantity };
      localStorage.setItem('settings', JSON.stringify(settings));
    },
    dateChange(date) {
      this.startDate = date;
      this.getPeriodicalStats();
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (settings) {
      this.period = settings.period;
      this.quantity = settings.quantity;
    }
    this.getPeriodicalStats();
  }
};
</script>
